import { render, staticRenderFns } from "./TagSharePieChart.vue?vue&type=template&id=784f4080&"
import script from "./TagSharePieChart.vue?vue&type=script&lang=js&"
export * from "./TagSharePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
